import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Make available globally for storage helpers
window._SUPABASE_URL = supabaseUrl;
window._SUPABASE_ANON_KEY = supabaseAnonKey;